module.exports = __webpack_public_path__ + "static/media/h3.a325c949.png";